import Questionnaire from './Questionnaire'

import './style.scss'

export { Questionnaire }
export default Questionnaire
